import {
  Button,
  Checkbox,
  Message,
  Spinner,
  Notes,
  LinkText,
  Popup
} from 'common/components';
import React, { useEffect } from 'react';
import { SubButtonType } from 'common/components/button';
import { Glossary, BoardGL } from 'common/utils/glossary';

interface DeleteLendingUserProps {
  isDisplay: boolean;
  deleteUser: string[];
  isLendingUserProcessing: boolean;
  isLendingUserProcessingFail: boolean;
  glossary: Glossary;
  onInit: () => void;
  onClickDelete: () => void;
  onClickClose: () => void;
}

interface CheckBoxState {
  /** 登録条件の同意にチェックしたか否か */
  agreeTerms: boolean;
}

export const DeleteLendingUserBoard: React.FC<DeleteLendingUserProps> = ({
  isDisplay,
  deleteUser,
  isLendingUserProcessing,
  isLendingUserProcessingFail,
  glossary,
  onInit,
  onClickDelete,
  onClickClose
}) => {
  const initCheckedState = {
    agreeTerms: false
  };

  /**  チェック状態の定義と変更 */
  const [checkedState, setCheckedState] = React.useState<CheckBoxState>(
    initCheckedState
  );

  useEffect(() => {
    setCheckedState(initCheckedState);
    isDisplay && onInit();
  }, [isDisplay]);

  /** 登録条件のチェックボックス押下時の処理 */
  const onClickTermsCheckBox = () => {
    setCheckedState({ ...checkedState, agreeTerms: !checkedState.agreeTerms });
  };

  /** チェック状態によって利用登録ボタンのサブタイプを制御 */
  let subButtonType: SubButtonType = 'invalid';
  if (checkedState.agreeTerms && isLendingUserProcessing == false) {
    subButtonType = 'highPriority';
  } else {
    subButtonType = 'invalid';
  }

  const onClickDeleteProcessing = () => {
    // 削除処理中はバックグラウンドをクリックしても何もしない
  };

  const _component =
    window.innerWidth > 639 || document.documentElement.clientWidth > 639 ? (
      <Popup
        className="deleteLendingUserBoard-popup"
        onClickBackground={
          isLendingUserProcessing ? onClickDeleteProcessing : onClickClose
        }
        data-test="deleteLendingUserBoard-popup"
        visible={isDisplay}
      >
        <div className="deleteLendingUserBoard">
          <Message type="message" data-test="deleteLendingUserBoard-message">
            {glossary.glx(BoardGL.removeOtherUser)}
          </Message>
          <Notes
            notes={[glossary.glx(BoardGL.rentalStopConfirmation)]}
            data-test={`deleteLendingUserBoard-notes`}
          />
          <div className="termsAgreementFlex">
            <Checkbox
              id="termsAgreement"
              value="termsAgreement"
              checked={checkedState.agreeTerms}
              onChange={onClickTermsCheckBox}
              data-test="deleteLendingUserBoard-termsCheckbox"
            />
            <LinkText
              type="checkBoxLabel"
              className="agreement-label"
              onClick={onClickTermsCheckBox}
              data-test="deleteLendingUserBoard-termsAgreementLabel"
            >
              {glossary.glx(BoardGL.acceptToCriteria)}
            </LinkText>
          </div>
          <div className="buttonFlex">
            <Button
              type="nextButton"
              subType={subButtonType}
              onClick={onClickDelete}
              data-test="deleteLendingUserBoard-nextButton"
            >
              {isLendingUserProcessing ? (
                <Spinner type="button" width={22} height={22} />
              ) : (
                glossary.glx(BoardGL.removeOtherUser)
              )}
            </Button>
            <Button
              className="cancelButton"
              type="toolButton"
              onClick={onClickClose}
              data-test="deleteLendingUserBoard-cancelButton"
            >
              {glossary.glx(BoardGL.cancel)}
            </Button>
          </div>
        </div>
      </Popup>
    ) : (
      <Popup
        className="deleteLendingUserBoard-popup"
        onClickBackground={
          isLendingUserProcessing ? onClickDeleteProcessing : onClickClose
        }
        data-test="deleteLendingUserBoard-popup"
        visible={isDisplay}
      >
        <div className="deleteLendingUserBoard">
          <Message type="message" data-test="deleteLendingUserBoard-message">
            {glossary.glx(BoardGL.removeOtherUser)}
          </Message>
          <Notes
            notes={[glossary.glx(BoardGL.rentalStopConfirmation)]}
            data-test={`deleteLendingUserBoard-notes`}
          />
          <div className="termsAgreementFlex">
            <Checkbox
              id="termsAgreement"
              value="termsAgreement"
              checked={checkedState.agreeTerms}
              onChange={onClickTermsCheckBox}
              data-test="deleteLendingUserBoard-termsCheckbox"
            />
            <LinkText
              type="checkBoxLabel"
              className="agreement-label"
              onClick={onClickTermsCheckBox}
              data-test="deleteLendingUserBoard-termsAgreementLabel"
            >
              {glossary.glx(BoardGL.acceptToCriteria)}
            </LinkText>
          </div>
          <Button
            type="nextButton"
            subType={subButtonType}
            onClick={onClickDelete}
            data-test="deleteLendingUserBoard-nextButton"
          >
            {isLendingUserProcessing ? (
              <Spinner type="button" width={22} height={22} />
            ) : (
              glossary.glx(BoardGL.removeOtherUser)
            )}
          </Button>
          <Button
            className="cancelButton"
            type="toolButton"
            onClick={onClickClose}
            data-test="deleteLendingUserBoard-cancelButton"
          >
            {glossary.glx(BoardGL.cancel)}
          </Button>
        </div>
      </Popup>
    );
  return isDisplay ? _component : null;
};
